import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why being creative sucks",
  "description": "",
  "published": "2009-01-04T00:00:00.000Z",
  "redirect_from": ["/blog/why-being-creative-sucks/swizec/24"],
  "categories": "commentary, food for thought, improvement",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Creativity is rather awesome, I'm certain we can all agree to that. Creativity drives the world forward, it opens our eyes to new scientific discoveries that sometimes help improve our lives, but mostly just make it more difficult for the average joe to understand. Hell, creativity even opens our eyes to new artistic discoveries, even though I don't think much progress has been made on that front in the past century, regression even, but we're picking up from even that in this new millenia that's slowly getting old so much we might even stop calling it new.`}</p>
    <p>{`But creativity has a dark side, a very brooding, very dark, very difficult side, a side that is almost unbearable, a side that gives `}{`_`}{`"come to the dark side we have cookies" `}{`_`}{`a whole new meaning, a side that ... oh shut the fuck up, you get the picture right? It's a very dark side.`}</p>
    <p>{`Everybody creative, for the sake of argument I include myself in this crowd, will probably agree with me when I say that the biggest problem with creativity is the creativity itself. Anythign and everything constantly makes a creative's mind give birth to new wonderful ideas,w hich all seem spectacular and awesome at the time. But when push comes to shove, you suddenly realise you're already working on so many ideas you couldn't possibly start working on another one. So you shelve it.`}</p>
    <p>{`Once you have time for this wonderful idea, which might be ten minutes later or ten years later, you suddenly realise it's turned cold and damp, very boring, moronic and even, dare I say, mediocre. In short, most of the ideas we come up with never get realised, never come to life and, quite simply, if someone less creative came upon one of them they would cherish and nurture the poor thing until it became ... something.`}</p>
    <p>{`So if you think you're creative, slow the fuck down, write down everything you come up with no matter how small, and as soon as you find somebody uncreative give them some of your shelved ideas you'll never have time to get to. Perhaps we can make the world a better place one uncreative person at a time.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      